/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  GovernorModule,
  GovernorModuleInterface,
} from "../../../contracts/Governor/GovernorModule";

const _abi = [
  {
    inputs: [],
    name: "NotAuthorized",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "previousAdmin",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "newAdmin",
        type: "address",
      },
    ],
    name: "AdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "beacon",
        type: "address",
      },
    ],
    name: "BeaconUpgraded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint64",
        name: "oldVoteExtension",
        type: "uint64",
      },
      {
        indexed: false,
        internalType: "uint64",
        name: "newVoteExtension",
        type: "uint64",
      },
    ],
    name: "LateQuorumVoteExtensionSet",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "proposalId",
        type: "uint256",
      },
    ],
    name: "ProposalCanceled",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "proposalId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "proposer",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address[]",
        name: "targets",
        type: "address[]",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "values",
        type: "uint256[]",
      },
      {
        indexed: false,
        internalType: "string[]",
        name: "signatures",
        type: "string[]",
      },
      {
        indexed: false,
        internalType: "bytes[]",
        name: "calldatas",
        type: "bytes[]",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "startBlock",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "endBlock",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "string",
        name: "description",
        type: "string",
      },
    ],
    name: "ProposalCreated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "proposalId",
        type: "uint256",
      },
    ],
    name: "ProposalExecuted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "proposalId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint64",
        name: "extendedDeadline",
        type: "uint64",
      },
    ],
    name: "ProposalExtended",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "proposalId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "eta",
        type: "uint256",
      },
    ],
    name: "ProposalQueued",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "oldProposalThreshold",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newProposalThreshold",
        type: "uint256",
      },
    ],
    name: "ProposalThresholdSet",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "oldQuorumNumerator",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newQuorumNumerator",
        type: "uint256",
      },
    ],
    name: "QuorumNumeratorUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "oldTimelock",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "newTimelock",
        type: "address",
      },
    ],
    name: "TimelockChange",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "implementation",
        type: "address",
      },
    ],
    name: "Upgraded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "voter",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "proposalId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint8",
        name: "support",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "weight",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "string",
        name: "reason",
        type: "string",
      },
    ],
    name: "VoteCast",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "oldVotingDelay",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newVotingDelay",
        type: "uint256",
      },
    ],
    name: "VotingDelaySet",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "oldVotingPeriod",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newVotingPeriod",
        type: "uint256",
      },
    ],
    name: "VotingPeriodSet",
    type: "event",
  },
  {
    inputs: [],
    name: "BALLOT_TYPEHASH",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "COUNTING_MODE",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "accessControl",
    outputs: [
      {
        internalType: "contract IDAOAccessControl",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "proposalId",
        type: "uint256",
      },
      {
        internalType: "uint8",
        name: "support",
        type: "uint8",
      },
    ],
    name: "castVote",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "proposalId",
        type: "uint256",
      },
      {
        internalType: "uint8",
        name: "support",
        type: "uint8",
      },
      {
        internalType: "uint8",
        name: "v",
        type: "uint8",
      },
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32",
      },
    ],
    name: "castVoteBySig",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "proposalId",
        type: "uint256",
      },
      {
        internalType: "uint8",
        name: "support",
        type: "uint8",
      },
      {
        internalType: "string",
        name: "reason",
        type: "string",
      },
    ],
    name: "castVoteWithReason",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "targets",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "values",
        type: "uint256[]",
      },
      {
        internalType: "bytes[]",
        name: "calldatas",
        type: "bytes[]",
      },
      {
        internalType: "bytes32",
        name: "descriptionHash",
        type: "bytes32",
      },
    ],
    name: "execute",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "blockNumber",
        type: "uint256",
      },
    ],
    name: "getVotes",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "proposalId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasVoted",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "targets",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "values",
        type: "uint256[]",
      },
      {
        internalType: "bytes[]",
        name: "calldatas",
        type: "bytes[]",
      },
      {
        internalType: "bytes32",
        name: "descriptionHash",
        type: "bytes32",
      },
    ],
    name: "hashProposal",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IVotesUpgradeable",
        name: "_token",
        type: "address",
      },
      {
        internalType: "contract ITimelock",
        name: "_timelock",
        type: "address",
      },
      {
        internalType: "uint64",
        name: "_initialVoteExtension",
        type: "uint64",
      },
      {
        internalType: "uint256",
        name: "_initialVotingDelay",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_initialVotingPeriod",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_initialProposalThreshold",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_initialQuorumNumeratorValue",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_accessControl",
        type: "address",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "lateQuorumVoteExtension",
    outputs: [
      {
        internalType: "uint64",
        name: "",
        type: "uint64",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "moduleFactory",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "proposalId",
        type: "uint256",
      },
    ],
    name: "proposalDeadline",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "proposalId",
        type: "uint256",
      },
    ],
    name: "proposalEta",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "proposalId",
        type: "uint256",
      },
    ],
    name: "proposalSnapshot",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "proposalThreshold",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "proposalId",
        type: "uint256",
      },
    ],
    name: "proposalVotes",
    outputs: [
      {
        internalType: "uint256",
        name: "againstVotes",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "forVotes",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "abstainVotes",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "targets",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "values",
        type: "uint256[]",
      },
      {
        internalType: "bytes[]",
        name: "calldatas",
        type: "bytes[]",
      },
      {
        internalType: "string",
        name: "description",
        type: "string",
      },
    ],
    name: "propose",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "proxiableUUID",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "targets",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "values",
        type: "uint256[]",
      },
      {
        internalType: "bytes[]",
        name: "calldatas",
        type: "bytes[]",
      },
      {
        internalType: "bytes32",
        name: "descriptionHash",
        type: "bytes32",
      },
    ],
    name: "queue",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "blockNumber",
        type: "uint256",
      },
    ],
    name: "quorum",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "quorumDenominator",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "quorumNumerator",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "target",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "relay",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint64",
        name: "newVoteExtension",
        type: "uint64",
      },
    ],
    name: "setLateQuorumVoteExtension",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "newProposalThreshold",
        type: "uint256",
      },
    ],
    name: "setProposalThreshold",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "newVotingDelay",
        type: "uint256",
      },
    ],
    name: "setVotingDelay",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "newVotingPeriod",
        type: "uint256",
      },
    ],
    name: "setVotingPeriod",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "proposalId",
        type: "uint256",
      },
    ],
    name: "state",
    outputs: [
      {
        internalType: "enum IGovernorUpgradeable.ProposalState",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "timelock",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "token",
    outputs: [
      {
        internalType: "contract IVotesUpgradeable",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "newQuorumNumerator",
        type: "uint256",
      },
    ],
    name: "updateQuorumNumerator",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract ITimelock",
        name: "newTimelock",
        type: "address",
      },
    ],
    name: "updateTimelock",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newImplementation",
        type: "address",
      },
    ],
    name: "upgradeTo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newImplementation",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "upgradeToAndCall",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "version",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "votingDelay",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "votingPeriod",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
];

const _bytecode =
  "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";

type GovernorModuleConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: GovernorModuleConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class GovernorModule__factory extends ContractFactory {
  constructor(...args: GovernorModuleConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<GovernorModule> {
    return super.deploy(overrides || {}) as Promise<GovernorModule>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): GovernorModule {
    return super.attach(address) as GovernorModule;
  }
  override connect(signer: Signer): GovernorModule__factory {
    return super.connect(signer) as GovernorModule__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): GovernorModuleInterface {
    return new utils.Interface(_abi) as GovernorModuleInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): GovernorModule {
    return new Contract(address, _abi, signerOrProvider) as GovernorModule;
  }
}
